import Row from '@sdk/components/ui/spacing/Row';
import Text16 from '@sdk/components/ui/typography/Text16';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import useConfig from '@sdk/config/useConfig';

import { useBillingInfo } from '@web/account/billing/BillingInfoContext';

import { useBillingInformationSection } from './billingInformationSection.hooks';
import {
  BillingAddressLabel,
  BillingInfoHeader,
  BillingInfoRow,
  BillingInfoSectionContainer,
  BillingInfoText,
  EditIcon,
} from './billingInformationSection.styles';

type Props = {
  emails: string[];
  onEdit: () => void;
};

export const BillingInformationSection = ({ emails, onEdit }: Props) => {
  const { FEATURE_FLAGS } = useConfig();
  const { billingAddressLabel } = useBillingInformationSection();
  const { billingInfo } = useBillingInfo();
  const shouldShowEmails = emails.some(Boolean);

  return (
    <BillingInfoSectionContainer>
      <BillingInfoHeader>
        <Text16 semiBold themeColor={ThemeColorType.primary}>
          {gettext('Billing information')}
        </Text16>
        <EditIcon onClick={onEdit} />
      </BillingInfoHeader>

      <BillingInfoRow>
        <BillingInfoText>{gettext('Company name')}</BillingInfoText>
        <BillingInfoText>{billingInfo.billingDetails}</BillingInfoText>
      </BillingInfoRow>

      {FEATURE_FLAGS.TAX_CALCULATIONS_ENABLED && (
        <BillingInfoRow>
          <BillingInfoText>{gettext('Billing address')}</BillingInfoText>
          {!billingAddressLabel ? (
            <Text14 themeColor={ThemeColorType.danger}>
              {gettext('[Missing billing address]')}
            </Text14>
          ) : (
            <BillingAddressLabel>{billingAddressLabel}</BillingAddressLabel>
          )}
        </BillingInfoRow>
      )}

      {shouldShowEmails && (
        <Row pBottom={20}>
          <BillingInfoText>{gettext('Billing email')}</BillingInfoText>
          <Column mLeft={'auto'}>
            {emails.map((email) => (
              <BillingInfoText textAlign="end" key={email}>
                {email}
              </BillingInfoText>
            ))}
          </Column>
        </Row>
      )}
    </BillingInfoSectionContainer>
  );
};
